var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',_vm._g({staticClass:"list-stacked list-stacked--small",attrs:{"name":"list","tag":"ul","appear":""}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }